<template>
    <Layout>
        <div class="col-12">
            <Breadcrumb :items="breadcrumbItems" />
            <div class="row mt-3 mb-3 align-items-center">
                <div class="col-sm-6">
                    <b-btn
                        class="btn btn-pdv-gradient-blue"
                        @click="openModalToCreate"
                    >
                        <i class="fe-plus-circle" aria-hidden="true"></i>
                        {{ getI18n(i18nKey, 'BUTTONS.nova_campanha') }}
                    </b-btn>
                </div>
            </div>
            <div class="card card-pdv">
                <PageHeader :title="getI18n(i18nKey, 'TITLES.campanhas')" />
                <div class="card-body">
                    <api-mode-vuetable
                        ref="vuetable"
                        :fetch-data="fetch"
                        :fields="fields"
                        :per-page="perPage"
                        :additional-parameters="additionalParameters"
                        :empty-text="getI18n(i18nKey, 'MESSAGES.nenhuma_campanha')"
                    >
                        <template slot="is_active" slot-scope="props">
                            <b-badge :variant="props.rowData.is_active ? 'success' : 'secondary'">
                                {{ props.rowData.is_active ? i18nAtiva : i18nInativa }}
                            </b-badge>
                        </template>
                        <template slot="start_date" slot-scope="props">
                            {{ formatDateShort(props.rowData.start_date) || '—' }}
                        </template>
                        <template slot="end_date" slot-scope="props">
                            {{ formatDateShort(props.rowData.end_date) || '—' }}
                        </template>
                        <template slot="actions" slot-scope="props">
                            <div class="table-button-container text-right">
                                <more-table-button @onClick="openSetupModalForCampaign(props.rowData.id)" />
                            </div>
                        </template>
                    </api-mode-vuetable>
                </div>
            </div>
        </div>
        <loja-perfeita-campaign-setup-modal
            ref="setupModal"
            @refresh="refreshTable"
        />
    </Layout>
</template>

<script>
import ApiModeVuetable from '@src/components/ApiModeVuetable'
import PageHeader from '@/src/components/PageHeader.vue'
import Layout from '@layouts/main.vue'
import Breadcrumb from '@/src/components/Breadcrumb.vue'
import LojaPerfeitaService from '@src/services/dashboards/LojaPerfeitaService'
import MoreTableButton from '@/src/components/MoreTableButton.vue'
import LojaPerfeitaCampaignSetupModal from './lojaPerfeitaCampaignSetupModal.vue'
import Pagination from '@src/mixins/pagination.vue'
import Shared from '@src/mixins/shared.vue'
import vuetableFormatter from '@src/mixins/vuetableFormatters.vue'

const i18nKey = 'LOJA_PERFEITA'

export default {
    metaInfo() {
        return {
            title: this.getI18n(i18nKey, 'TITLES.loja_perfeita'),
        }
    },
    components: {
        ApiModeVuetable,
        PageHeader,
        Layout,
        Breadcrumb,
        MoreTableButton,
        LojaPerfeitaCampaignSetupModal,
    },
    mixins: [Pagination, Shared, vuetableFormatter],
    data() {
        return {
            i18nKey,
            additionalParameters: {},
            perPage: 10,
            fields: [
                { name: 'name', title: this.getI18n(i18nKey, 'TITLES.nome'), sortField: 'name' },
                { name: 'start_date', title: this.getI18n(i18nKey, 'TITLES.inicio'), sortField: 'start_date' },
                { name: 'end_date', title: this.getI18n(i18nKey, 'TITLES.fim'), sortField: 'end_date' },
                { name: 'is_active', title: this.getI18n(i18nKey, 'TITLES.status'), sortField: 'is_active' },
                { name: 'actions', title: '' },
            ],
        }
    },
    computed: {
        breadcrumbItems() {
            return [
                { text: 'Home', href: '/' },
                { text: this.getI18n(i18nKey, 'TITLES.loja_perfeita'), active: true },
            ]
        },
        i18nAtiva() {
            return this.getI18n(i18nKey, 'TITLES.ativa')
        },
        i18nInativa() {
            return this.getI18n(i18nKey, 'TITLES.inativa')
        },
    },
    mounted() {
        this.openSetupFromQuery()
    },
    methods: {
        fetch(url, params) {
            return LojaPerfeitaService.fetchVuetable('list', { params })
        },
        openSetupFromQuery() {
            const raw = this.$route.query.openSetup
            if (raw == null || raw === '') return
            const id = raw
            LojaPerfeitaService.getById(id)
                .then((res) => {
                    const c = res.data
                    if (c) {
                        this.$refs.setupModal.replaceModalData(c)
                        this.$nextTick(() => this.$refs.setupModal.showModal())
                    }
                })
                .catch(() => {})
                .finally(() => {
                    this.$router.replace({ name: 'lojaPerfeita', query: {} })
                })
        },
        openModalToCreate() {
            this.$refs.setupModal.replaceModalData({
                id: 0,
                name: '',
                start_date: '',
                end_date: '',
                is_active: true,
            })
            this.$nextTick(() => this.$refs.setupModal.showModal())
        },
        openSetupModalForCampaign(id) {
            LojaPerfeitaService.getById(id).then((res) => {
                const c = res.data
                if (c) {
                    this.$refs.setupModal.replaceModalData(c)
                    this.$nextTick(() => this.$refs.setupModal.showModal())
                }
            })
        },
        refreshTable() {
            this.$refs.vuetable.refresh()
        },
    },
}
</script>

